var SMI_ExtendComponent = (function () {
  "use strict";
  class SMI_ExtendComponent {
    sectionEl = null;
    constructor(sectionID) {
      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.checking = "false";
      this.handleCloseModal();      
      this.handleOldProductCard();
      this.addStyleExtendToHeader()
      this.handleCheckObj()
    }

    handleCheckObj(){
      try {
        let smi_extended_items = localStorage.getItem("smi_extended_items");
        if (!smi_extended_items) {
          let obj = {
            wishlist: [],
            compare: [],
            wishlist_link: "",
            compare_link: "",
            product_id: "",
            product_url: "",
            currentQVP: "",
            currentQAV: "",
          };
          localStorage.setItem("smi_extended_items", JSON.stringify(obj));
        }
      } catch (error) {
        
      }
    }

    addStyleExtendToHeader(){
      const styleElement = document.createElement('style')
      styleElement.textContent = `
      .smi-product-card-extend-general {
          z-index: 1;
          position: absolute;
          border-color: rgba(var(--color-foreground), 0.2) !important;
          top: calc(12px + var(--image-padding));
          right: calc(12px + var(--image-padding));
          width: 46px !important;
          gap: 8px 0px;
          flex-wrap: wrap;
          display: flex;
          @media (max-width: 768px) {
              top: calc(8px + var(--image-padding));
              right: calc(8px + var(--image-padding));
              width: calc(2px + (8px * 2) + (18px * var(--icon-scale))) !important;
              gap: 4px 0px;
          }
        }
        /*.smi-view-list .smi-product-card__actions{
          display: none;
        }*/
      `
      document.head.appendChild(styleElement);
    }

    handleOldProductCard(){
      // Select all elements with the class "extend"
      const elements = document.querySelectorAll('.smi-product-card-extend');
      // Convert NodeList to an array and remove elements

      let product_cards = document.querySelectorAll(`.smi-product-card`)
      Array.from(product_cards).forEach(element => {
        let product_card_thumbnail = element.querySelector(`.smi-product-card__thumbnail`)
        try {
          let product_card_extend = product_card_thumbnail.querySelector(`.smi-product-card-extend`)
          if(!element.querySelector(`.smi-product-data`)){
            let product_id = ""
            let product_url = ""
            let product_first_variant_or_selected_id = ""
            if(product_card_extend.querySelector(`.smi-quickview-container`) || product_card_extend.querySelector(`.smi-quickadd-container`)){
              if(product_card_extend.querySelector(`.smi-quickview-container`)){
                product_first_variant_or_selected_id = product_card_extend.querySelector(`.smi-quickview-container`).getAttribute('product-id')
                product_url = product_card_extend.querySelector(`.smi-quickview-container`).getAttribute(`product-url`)
              }else{
                product_first_variant_or_selected_id = product_card_extend.querySelector(`.smi-quickadd-container`).getAttribute('product-id')
                product_url = product_card_extend.querySelector(`.smi-quickadd-container`).getAttribute(`product-url`)
              }
            }
            if(product_card_extend.querySelector(`.smi-compare-container`) || product_card_extend.querySelector(`.smi-wishlist-container`)){
              if(product_card_extend.querySelector(`.smi-compare-container`)){
                product_id = product_card_extend.querySelector(`.smi-compare-container`).getAttribute(`product-id`)
              }else{
                product_id = product_card_extend.querySelector(`.smi-wishlist-container`).getAttribute(`product-id`)
              }
            }
            let obj_data = {
              id: product_id,
              url: product_url,
              selected_or_first_available_variant: {
                id: product_first_variant_or_selected_id
              }
              
            }
            let script_data = document.createElement('script')
            script_data.setAttribute('type', 'application/json')
            script_data.classList.add('smi-product-data')
            script_data.innerHTML=`
            {
              "id": "${product_id}",
              "url": "${product_url}",
              "selected_or_first_available_variant": {
                "id": "${product_first_variant_or_selected_id}"
              }
            }
            `
            element.append(script_data)
          }
          product_card_extend.parentNode.removeChild(product_card_extend);
        } catch (error) {}
        
        
        if(!product_card_thumbnail.querySelector(`.smi-product-card__actions`)){
          let product_card_actions = document.createElement('div')
          product_card_actions.classList.add('smi-product-card__actions')
          product_card_actions.innerHTML = `<div class="smi-product-card-extend-general"></div>`
          product_card_thumbnail.appendChild(product_card_actions)
        }
      });
    }

    handleCloseModal() {
      document.addEventListener("smiLiteModalClose", (e) => {
        localStorage.setItem("smiIOQV", 1);
        localStorage.setItem("smiIOQA", 1);
        localStorage.setItem("smi-loaded-qv", 1);
        localStorage.setItem("smi-loaded-qa", 1);
        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        let all_pops_false_qv = document.querySelectorAll(
          ".smi-quick-view-1-modal"
        );
        if (all_pops_false_qv && all_pops_false_qv.length) {
          all_pops_false_qv.forEach((item, i) => {
            if (item) {
              if (all_pops_false_qv.length > 1) {
                if (i > 0) {
                  item.classList.remove("smi-modal-on-animation");
                }
              } else {
                item.classList.remove("smi-modal-on-animation");
              }
              item.classList.remove("smi-modal-on");
            }
          });
        }

        let all_pops_false_qa = document.querySelectorAll(
          ".smi-quick-add-1-modal"
        );
        if (all_pops_false_qa && all_pops_false_qa.length) {
          all_pops_false_qa.forEach((item, i) => {
            if (item) {
              if (all_pops_false_qa.length > 1) {
                if (i > 0) {
                  item.classList.remove("smi-modal-on-animation");
                }
              } else {
                item.classList.remove("smi-modal-on-animation");
              }
              item.classList.remove("smi-modal-on");
            }
          });
        }

        let all_popsss = document.querySelectorAll(
          `.smi-quick-view-content-main`
        );
        if (all_popsss) {
          all_popsss.forEach((item, i) => {
            if (item) {
              item.innerHTML =
                '<div class="smi-quickview-loader"><div class="loader"></div></div>';
            }
          });
        }
        let all_popsss_qa = document.querySelectorAll(
          `.smi-quick-add-content-main`
        );
        if (all_popsss_qa) {
          all_popsss_qa.forEach((item, i) => {
            if (item) {
              item.innerHTML =
                '<div class="smi-quickadd-loader"><div class="loader"></div></div>';
            }
          });
        }

        if (document.getElementById(`smi-modal-bg`)) {
          document.getElementById(`smi-modal-bg`).style = "";
        } else {
          // console.log('-----empty modal')
        }
      });
    }
    
  }
  return SMI_ExtendComponent;
})();





